module.exports = __webpack_public_path__ + "media/images/success-img/layer-9-cc9659b4b2d924445fe429829c77d3e9.png";